import React, { useEffect } from 'react';
import { PaymentStatus, V2PaymentResponse } from '@api';
import { Failed } from './Failed';
import { Undefined } from './Undefined';
import { InProgress } from './InProgress';
import SummaryListComp from './SummaryListComp';

export interface Props {
  response: V2PaymentResponse;
  onAnotherCard?: () => void;
  onCancel?: () => void;
  onInit?: () => void;
  resetOnInit?: boolean;
  result?: any;
}

export function ResultComp({ resetOnInit, onInit, response, onAnotherCard, onCancel }: Props) {
  
  useEffect(() => () => {
    if (resetOnInit) {
      onInit();
    }
  }, []);
  
  switch (response?.status) {
    case PaymentStatus.SUCCESSFUL:
    case PaymentStatus.SUCCESSFUL_BY_PASS:
    case PaymentStatus.SUCCESSFUL_WAITING_COURSES:
      return <SummaryListComp />;
    case  PaymentStatus.FAILED:
      return <Failed
        onAnotherCard={onAnotherCard}
        onCancel={onCancel}
        reason={response.responseText}
      />;
    case PaymentStatus.UNDEFINED:
      return <Undefined />;
    case PaymentStatus.IN_PROGRESS:
      return <InProgress />;
    default:
      return null;
  }
}